import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/categories`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  addCategory({ commit }, payload: { category: object }) {
    return axiosInstance.post(baseUrl, payload.category)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
